export default __webpack_public_path__ + "static/1136-fdb411974ce393b1b70c5014b0b80a85.gif";